import IMask from 'imask';

export default function(input){
	let mask = IMask(input, {mask: '+{7}(000)000-00-00'});
	let show_mask = () => mask.updateOptions({lazy: false});
	let hide_mask = () => mask.updateOptions({lazy: true});

	input.addEventListener('mouseenter', show_mask);
	input.addEventListener('focus', show_mask);

	input.addEventListener('mouseleave', () => document.activeElement === input ? null : hide_mask());
	input.addEventListener('blur', () => mask.masked.rawInputValue ? null : hide_mask());

}